export const azureTokenInfo = (async (): Promise<any> => {
  return await window
    .fetch(
      "https://flowengineirr.azurewebsites.net/api/HttpTrigger1?code=A6e0_N_PbKmeQ6AehX_3Gq6vvMR0ZGLae8CpWXWx8c1OAzFuuVaCwg==",
      {}
    )
    // eslint-disable-next-line github/no-then
    .then((response) => {
      return response.json();
    });
})();
